export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '점검구분' }, { name: '재해형태' }, { name: '소속명' }, { name: '부서명' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: { // 점검구분
        let list = func.getContent(value).selectChecklist ? func.getContent(value).selectChecklist.toString() : ''
        list = list.replace("outdoor", "온열질환 예방 안전보건점검표 (실외)")
        list = list.replace("indoor", "온열질환 예방 안전보건점검표 (실내)")
        list = list.replace("coldPrevention", "한랭질환 예방 안전보건점검표")
        return list
      }
      case 2: return func.getContent(value).stdInfo.재해형태 // 재해형태
      case 3: return func.getContent(value).stdInfo.department // 소속명
      case 4: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]')

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': 'content$body.stdInfo.section*%[:default_skw]%' ? returnData.push('content$body.stdInfo.section*%[:default_skw]%') : returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
